import { render, staticRenderFns } from "./QuizEvaluation.vue?vue&type=template&id=32c23846&scoped=true&"
import script from "./QuizEvaluation.vue?vue&type=script&lang=js&"
export * from "./QuizEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./QuizEvaluation.vue?vue&type=style&index=0&id=32c23846&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c23846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VIcon,VRadio,VRadioGroup})
